import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { listScrollKey, restoreScrollForList } from "@/lib/scrollRestore";

/**
 * Fait défiler vers l’élément dont l’id correspond au hash (#comment, #contact, etc.).
 * React Router ne le fait pas tout seul après navigation.
 */
export function ScrollToHash() {
  const location = useLocation();

  /** Changement de page sans ancre → tête de page (logo, liens internes). */
  useEffect(() => {
    const raw = location.hash?.replace(/^#/, "").trim() || "";
    if (raw && !raw.includes("session_id=")) return;
    const key = listScrollKey(location.pathname, location.search);
    if (restoreScrollForList(key)) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [location.pathname, location.search, location.hash]);

  useEffect(() => {
    const raw = location.hash?.replace(/^#/, "").trim() || "";
    if (!raw || raw.includes("session_id=")) return;

    const scrollToId = () => {
      const el = document.getElementById(raw);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    scrollToId();
    const t = window.setTimeout(scrollToId, 80);
    const t2 = window.setTimeout(scrollToId, 250);
    return () => {
      window.clearTimeout(t);
      window.clearTimeout(t2);
    };
  }, [location.pathname, location.hash]);

  return null;
}
